
      var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 36.666,
  cy: 36.666,
  r: 28.535,
  fill: "var(--theme-light,#e2cff7)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.93
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M68.964 71.036a1.465 1.465 0 1 0 2.072-2.072L70 70l-1.036 1.036ZM70 70l1.036-1.036L57.702 55.63l-1.035 1.035-1.036 1.036 13.333 13.334L70 70Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"80\" height=\"80\" viewBox=\"0 0 80 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<circle cx=\"36.6665\" cy=\"36.6665\" r=\"28.535\" fill=\"var(--theme-light,#e2cff7)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.93\"/>\r\n<path d=\"M68.9639 71.0357C69.536 71.6079 70.4636 71.6079 71.0357 71.0357C71.6079 70.4636 71.6079 69.536 71.0357 68.9639L69.9998 69.9998L68.9639 71.0357ZM69.9998 69.9998L71.0357 68.9639L57.7024 55.6306L56.6665 56.6665L55.6306 57.7024L68.9639 71.0357L69.9998 69.9998Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/search.5224b40b68fff466eb9937243bab64e1.svg"),
        {
          React: SvgSearch,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      